import React from "react";
import { ShoppingList } from "./ShoppingList";

export const Main = () => {
	return <section>
		<h1>Välkommen till Önskelistemaskinen v3</h1>
		<hr />
		<ShoppingList />
	</section>;
}